import React, { useState, useEffect } from "react";
import bosfoto from "./../img/blankimage.png";
import downloadbtn from "./../img/downloadbtn.png";
import Api from "../common/api";

const OperatingReport = () => {
  const lang = localStorage.getItem("lang");
  const [datas, setData] = useState([]);
  const [years, setYears] = useState([]);
  const [activeYear, setActiveYear] = useState([]);

  React.useEffect(() => {
    Api.get("/Documents/list/7").then((res) => {
      setData(res.data.items);
      var year = [];
      res.data.items.map((val, index) => {
        //console.log(val.Create_date);
        var newYear = new Date(val.Create_date.split("(")[1].split(")")[0] * 1)
          .toLocaleDateString("tr-TR")
          .split(".")[2];
          //console.log(newYear);
        if (year.findIndex((x) => x.name == newYear) == -1) {
          year.push({
            id: index,
            name: newYear,
          });
        }
      });
      setYears(year);
      setActiveYear(year[year.length - 1].name);
    });
  }, []);

  return (
    <div className="monthly-publish-container">
      {/* <div className="year-tabs">
        <ul>
          {years
            ? years.map((tab) => {
                return (
                  <>
                    <li
                      className={
                        tab.name === activeYear ? "years active" : "years"
                      }
                      onClick={() => {
                        setActiveYear(tab.name);
                      }}
                    >
                      {tab.name}
                    </li>
                  </>
                );
              })
            : null}
        </ul>
            </div>*/}
      <div className="publications-items">
        <div className="publications-container-item">
          {datas
            ? datas
                .filter(
                  (x) =>
                    new Date(x.Create_date.split("(")[1].split(")")[0] * 1)
                      .toLocaleDateString("tr-TR")
                      .split(".")[2] == activeYear
                )
                .map((data) => (
                  lang == "en" ? (
                    <>
                    <a
                      href={"https://sankoenerji.com.tr" + data.File_En}
                      target="_blank"
                      className="monthly-item"
                    >
                      <h1>{data.Name_EN}</h1>
                      <div className="basliklar">
                        <img
                          className="kapak-foto-blank"
                          src={
                            "https://sankoenerji.com.tr" +
                            data.Thumb_En
                          }
                          alt={data.Name_EN}
                        />
                      </div>
                    </a>
                  </>

                  ):(
                    <>
                    <a
                      href={"https://sankoenerji.com.tr" + data.Image}
                      target="_blank"
                      className="monthly-item"
                    >
                      <h1>{data.Name_TR}</h1>
                      <div className="basliklar">
                        <img
                          className="kapak-foto-blank"
                          src={
                            "https://sankoenerji.com.tr" +
                            data.Document_type
                          }
                          alt={data.Name_TR}
                        />
                      </div>
                    </a>
                  </>
                  )
                 
                ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default OperatingReport;
